import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_page_head = _resolveComponent("page-head")
  const _component_dg_mobile_notice = _resolveComponent("dg-mobile-notice")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_head),
    _createVNode(_component_dg_mobile_notice),
    _createVNode(_component_router_view)
  ], 64 /* STABLE_FRAGMENT */))
}